import type * as SchemaTypes from '../types';

import type { DealerMarketDataFragment } from './DealerMarketData';
import type { BankDealerMarketDataFragment } from './BankDealerMarketData';
import type { NzFeesDealerMarketDataFragment } from './NzFeesDealerMarketData';
import { gql } from '@apollo/client';
import { DealerMarketDataFragmentDoc } from './DealerMarketData';
import { BankDealerMarketDataFragmentDoc } from './BankDealerMarketData';
import { NzFeesDealerMarketDataFragmentDoc } from './NzFeesDealerMarketData';
export type ApplicationMarketTypeFragment_DefaultApplicationMarket_Fragment = (
  { __typename: 'DefaultApplicationMarket' }
  & Pick<SchemaTypes.DefaultApplicationMarket, 'type'>
);

export type ApplicationMarketTypeFragment_NewZealandApplicationMarket_Fragment = (
  { __typename: 'NewZealandApplicationMarket' }
  & Pick<SchemaTypes.NewZealandApplicationMarket, 'type'>
  & { ppsr: (
    { __typename: 'DealershipMarket' }
    & DealerMarketDataFragment
  ), estFee: (
    { __typename: 'DealershipMarket' }
    & DealerMarketDataFragment
  ), bankEstFee: (
    { __typename: 'BankDealershipMarket' }
    & BankDealerMarketDataFragment
  ), nzFees: (
    { __typename: 'NzFeesDealershipMarket' }
    & NzFeesDealerMarketDataFragment
  ) }
);

export type ApplicationMarketTypeFragment_SingaporeApplicationMarket_Fragment = (
  { __typename: 'SingaporeApplicationMarket' }
  & Pick<SchemaTypes.SingaporeApplicationMarket, 'type'>
  & { coe: (
    { __typename: 'DealershipMarket' }
    & DealerMarketDataFragment
  ) }
);

export type ApplicationMarketTypeFragmentFragment = ApplicationMarketTypeFragment_DefaultApplicationMarket_Fragment | ApplicationMarketTypeFragment_NewZealandApplicationMarket_Fragment | ApplicationMarketTypeFragment_SingaporeApplicationMarket_Fragment;

export const ApplicationMarketTypeFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment ApplicationMarketTypeFragment on ApplicationMarketType {
  ... on SingaporeApplicationMarket {
    type
    coe {
      ...DealerMarketData
    }
  }
  ... on NewZealandApplicationMarket {
    type
    ppsr {
      ...DealerMarketData
    }
    estFee {
      ...DealerMarketData
    }
    bankEstFee {
      ...BankDealerMarketData
    }
    nzFees {
      ...NzFeesDealerMarketData
    }
  }
  ... on DefaultApplicationMarket {
    type
  }
}
    `;